module.exports = __webpack_public_path__ + "static/img/login_top.597ec0a8.png";